import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { IfPermission } from '@folio/stripes-core';
import { Button, Icon } from '@folio/stripes-components';
import { FormattedMessage } from 'react-intl';

function ImportTemplate(props) {
  const inputFile = useRef(null);
  let fileReader;

  const onButtonClick = () => {
    inputFile.current.click();
  };

  const onReadFileContenet = () => {
    const fileData = JSON.parse(fileReader.result);
    props.setInitialValues({
      templateInfo: {
        name: fileData?.name,
        description: fileData?.description,
        code: fileData?.code,
        isDefault: fileData?.isDefault,
        isLocked: fileData?.isLocked,
        active: fileData?.active,
      },
      templateFields: fileData?.templateFields,
    });
  };

  const handleFileUpload = (e) => {
    const { files } = e.target;
    if (files && files.length) {
      fileReader = new FileReader();
      fileReader.onloadend = onReadFileContenet;
      fileReader.readAsText(files[0]);
    }
  };

  return (
    <IfPermission perm="ui-plugin-inventory-templates.inventoryTemplates.import">
      <input
        style={{ display: 'none' }}
        accept=".json"
        ref={inputFile}
        onChange={handleFileUpload}
        type="file"
      />
      <Button
        id="inventory-templates-plugin-import-template-import-btn"
        buttonStyle="primary"
        onClick={onButtonClick}
        onMouseDown={(e) => e.preventDefault()}
        marginBottom0
      >
        <Icon icon="lightning">
          <FormattedMessage
            id="ui-plugin-inventory-templates.buttons.importTemplate"
            defaultMessage="Import template"
          />
        </Icon>
      </Button>
    </IfPermission>
  );
}

ImportTemplate.propTypes = {
  setInitialValues: PropTypes.func,
};

export default ImportTemplate;
